



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import { ChainModule } from '@/store/modules/chain.module'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import SideBar from '@/components/SideBar.vue'

@Component({
  components: {
    Icon,
    LoaderWrapper,
    SelectV2,
    SideBar
  }
})
export default class BillingDetailsPage extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  isLoading: boolean = false

  get batchId () {
    return this.$route.params.batch
  }

  get userId () {
    return this.$route.params.user
  }

  get selectedBatch () {
    return this.$store.state.chain.selectedBatch
  }

  get pagination () {
    return this.$store.state.chain.billingBatchPagination
  }

  get batchUsersCommissions () {
    return this.$store.state.chain.batchUsersCommissions
  }

  get userListItems () {
    return this.batchUsersCommissions
      .filter((commission: any) => !!commission.settings)
      .map((commission: any) => {
        return {
          key: commission.user.id,
          value: commission.user.id,
          content: `${commission.user.firstName} ${commission.user.lastName}`
        }
      })
  }

  get selectedUser () {
    return this.userId ? +this.userId : undefined
  }

  get tabs () {
    return [
      {
        label: 'Details & Comissions',
        icon: 'chart',
        to: this.commissionsRoute
      },
      {
        label: 'Invoices',
        icon: 'task',
        to: this.invoiceRoute
      },
      {
        label: 'Settings',
        icon: 'settings',
        to: this.settingsRoute
      }
    ]
  }

  get commissionsRoute (): { name: string, params: { [key: string]: string } } {
    return {
      name: 'admin-billing-details-commissions',
      params: this.navigationRouteParams
    }
  }

  get invoiceRoute (): { name: string, params: { [key: string]: string } } {
    return {
      name: 'admin-billing-details-invoices',
      params: this.navigationRouteParams
    }
  }

  get settingsRoute (): { name: string, params: { [key: string]: string } } {
    return {
      name: 'admin-billing-details-settings',
      params: this.navigationRouteParams
    }
  }

  get navigationRouteParams (): { [key: string]: string } {
    const params: { [key: string]: string } = {
      batch: this.batchId
    }
    if (this.$route.params.user) {
      params.user = this.$route.params.user
    }
    return params
  }

  async mounted () {
    this.fetchPagination()
    this.$watch('batchId', async () => {
      this.fetchPagination()
    })
  }

  async fetchPagination () {
    this.isLoading = true
    const options: { user?: string, batch: string } = {
      batch: this.batchId
    }
    if (this.userId) {
      options.user = this.userId
      await this.chainModuleInstance.fetchUserBillingBatch({
        batchId: this.batchId,
        userId: this.userId
      })
    } else {
      await this.chainModuleInstance.fetchBillingBatch(+this.batchId)
    }

    await this.chainModuleInstance.fetchBillingBatchPagination(options)
    this.$forceUpdate()
    this.isLoading = false
  }

  get isInvoiceRouteActive () {
    return this.$route.name === 'admin-billing-details-invoices'
  }

  goToBatch (batchId: number | string, userId?: string | number) {
    const params: { [key: string]: string } = {
      batch: batchId.toString()
    }

    const localUserId = userId === undefined ? this.userId : userId
    if (localUserId) {
      params.user = localUserId.toString() as string
    }

    this.$router.push({
      name: this.isInvoiceRouteActive ? 'admin-billing-details-invoices' : 'admin-billing-details-commissions',
      params: params
    })
  }

  async goNext () {
    this.goToBatch(this.pagination.next)
  }

  async goPrev () {
    this.goToBatch(this.pagination.prev)
  }

  selectUser (value: any) {
    if (+this.userId === value) {
      return
    }
    if (!value && !this.userId) {
      return
    }
    this.goToBatch(this.batchId, value)
    this.fetchPagination()
  }
}
